module.exports = __webpack_public_path__ + "img/icon_all_history.83229893.svg";